/** Grace period before treating popup.closed as user cancellation (COOP can sever opener early). */
export const POPUP_CLOSED_CANCEL_GRACE_MS = 2500;
export function nextPopupClosePollState(closed, state, nowMs, graceMs = POPUP_CLOSED_CANCEL_GRACE_MS) {
    if (!closed) {
        return { state: { graceStartedAtMs: null }, shouldCancel: false };
    }
    if (state.graceStartedAtMs == null) {
        return { state: { graceStartedAtMs: nowMs }, shouldCancel: false };
    }
    if (nowMs - state.graceStartedAtMs >= graceMs) {
        return { state, shouldCancel: true };
    }
    return { state, shouldCancel: false };
}
//# sourceMappingURL=web-auth-popup-close.js.map